export default "__VITE_ASSET__DGigdu8r__"